module.exports = __webpack_public_path__ + "static/media/Games_Image@3x.7e273ba2.png";